import React, { useState, useEffect } from 'react';
import AdminDashboard from './AdminDashboard';
import Swal from 'sweetalert2';
import '../../assets/css/admin/allcourses.css';

const AllExternalDegrees = () => {
    const [externalDegrees, setExternalDegrees] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [filteredDegrees, setFilteredDegrees] = useState([]);

    useEffect(() => {
        fetchExternalDegrees();
    }, []);

    const fetchExternalDegrees = async () => {
        try {
            const response = await fetch('https://api.myskills.lk/externalDegree/all');
            const data = await response.json();
            setExternalDegrees(data);
            setFilteredDegrees(data); // Initialize filteredDegrees with all degrees
        } catch (error) {
            console.error('Error fetching external degrees:', error);
        }
    };

    // Real-time filtering effect
    useEffect(() => {
        if (!searchTerm.trim()) {
            // If search is empty, show all degrees
            setFilteredDegrees(externalDegrees);
            return;
        }
        
        // Filter external degrees based on multiple fields
        const filtered = externalDegrees.filter(degree => 
            (degree.courseName && degree.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (degree.university && degree.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
            (degree.duration && degree.duration.toLowerCase().includes(searchTerm.toLowerCase()))
        );
        
        setFilteredDegrees(filtered);
    }, [searchTerm, externalDegrees]);

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleDelete = async (externalDegreeId) => {
        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to delete this external degree?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetch(`https://api.myskills.lk/externalDegree/delete/${externalDegreeId}`, {
                        method: 'POST'
                    });
                    if (response.ok) {
                        const updatedDegrees = externalDegrees.filter(externalDegree => externalDegree.id !== externalDegreeId);
                        setExternalDegrees(updatedDegrees);
                        // Also update filtered degrees
                        setFilteredDegrees(updatedDegrees.filter(degree => 
                            !searchTerm || 
                            (degree.courseName && degree.courseName.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (degree.university && degree.university.toLowerCase().includes(searchTerm.toLowerCase())) ||
                            (degree.duration && degree.duration.toLowerCase().includes(searchTerm.toLowerCase()))
                        ));
                        
                        // Show success message
                        Swal.fire({
                            title: "Deleted!",
                            text: "The external degree has been deleted.",
                            icon: "success"
                        });
                    } else {
                        console.error('Failed to delete external degree');
                        Swal.fire({
                            title: "Error!",
                            text: "Failed to delete the external degree.",
                            icon: "error"
                        });
                    }
                } catch (error) {
                    console.error('Error deleting external degree:', error);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to delete the external degree.",
                        icon: "error"
                    });
                }
            }
        });
    };


    return (
        <div>
            <AdminDashboard />

            <div className='AllViews-admin-course'>
                <div className="search-icon-admin admin-course-search">
                    <h1>ALL EXTERNAL DEGREES</h1>
                    <form>
                        <input 
                            type="text" 
                            value={searchTerm}
                            onChange={handleSearch}
                            placeholder='Search Item' 
                        />
                        <input type="submit" value="SEARCH" onClick={(e) => e.preventDefault()} />
                    </form>
                </div>

                <div className="scroller-box">
                    <div className="table-course">
                    <table>
                            <thead>
                            <tr>
                                    <th>External Degree Name</th>
                                    <th>Institute Name</th>
                                    <th>Start Date</th>
                                    <th>Duration</th>
                                    <th>View</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredDegrees.length > 0 ? (
                                    filteredDegrees.map((externalDegree) => (
                                        <tr key={externalDegree.id}>
                                            <td>{externalDegree.courseName}</td>
                                            <td>{externalDegree.university}</td>
                                            <td>{externalDegree.startDate ? new Date(externalDegree.startDate).toLocaleDateString('en-CA') : ''}</td>
                                            <td>{externalDegree.duration}</td>
                                            <td>
                                                {externalDegree.website ? (
                                                    <a href={externalDegree.website} target="_blank" rel="noopener noreferrer" id='view-website'>WEBSITE</a>
                                                ) : (
                                                    <span style={{ color: '#999' }}>No Website</span>
                                                )}
                                            </td>
                                            <td id='action-buttons'>
                                                <a href="#!" id='del-details' onClick={() => handleDelete(externalDegree.id)}>DELETE</a>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="6" style={{textAlign: 'center'}}>No external degrees found matching your search</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllExternalDegrees;
